import {IModalDialogHandler} from "../dialog/dialog.service.interface";

export interface IConfirmLugasCoolingOffLogoutDialogOptions {
    onAccept: () => Promise<void>;
    onReject: () => Promise<void>;
}

export enum DialogResult {
    Accepted,
    Rejected
}

export interface ISpecificDialogsService {
    enforceHybridAppModal(analyticsOnClick?: {
        category: string;
        action?: string;
        label?: string;
        value?: any;
        omitStructuredLogger?: boolean;}
    ): IModalDialogHandler;
    showLugasCooldownPopup(): IModalDialogHandler;
    showLugasActivePopup(): IModalDialogHandler;
    showConfirmLugasCoolingOffLogout(options: IConfirmLugasCoolingOffLogoutDialogOptions): Promise<DialogResult>;
    showLoginPopup(confirmClicked: ()=> void): IModalDialogHandler;
    showModifyBiometricDialog(): IModalDialogHandler;
    showLogoutGamblingSessionSummary(): Promise<DialogResult>;
}
